import React from 'react';

import { scrollTo } from './functions.js';

// inline list of single letters, that act as anchor points
// props :letter (single character)
// limited interactivity - scroll to anchor target.

const LetterSelect = React.createClass({

    scroll: function(target, e){

        e.preventDefault();

        var targetElement = document.getElementById( target );
        var targetOffset = targetElement.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop -32;
        scrollTo( document.body , targetOffset , 600);

    },

    render: function(){

        if ( this.props.active == false ) {

            return (
                <li className="letter--select--item letter__disabled">
                    { this.props.letter }
                </li>
            );

        }

        else {

            return (
                <li className="letter--select--item">
                    <a href={ '#' + this.props.letter } onClick={ (event) => this.scroll( this.props.letter, event ) }>
                        { this.props.letter }
                    </a>
                </li>
            );

        }
    }

});

export default LetterSelect;


/** WEBPACK FOOTER **
 ** ./app/LetterSelect.jsx
 **/